import React from 'react';
import './ProgressBar.scss'

export interface ProgressBarProps {
    percent: string;
    width: string;
    height: string;
    isBlueColor?: boolean;
    ariaLabel?: string;
    ariaLabelledBy?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
    const valueNow = Math.min(100, Math.max(0, Number(props.percent) || 0));
    return (
        <div
            className='progressBar'
            style={{ width: `${props.width}`, height: `${props.height}` }}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={valueNow}
            aria-labelledby={props.ariaLabelledBy}
            aria-label={
              props.ariaLabelledBy
                ? undefined
                : props.ariaLabel || `Account opening progress ${valueNow}%`
            }
        >
            <div className={'bar' + (props.isBlueColor ? ' isBlue' : '')} style={{ width: `${props.percent}%` }}>
            </div>
        </div>
    );
}

export default ProgressBar;
